module.exports = __webpack_public_path__ + "static/img/about_banner.310bd53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about_banner.png
// module id = u8C5
// module chunks = 1